/**
 * Label keys for the ContextSwitcher (FLIGHT-369 multi-fund context switcher).
 *
 * Resolved at runtime via `useBranding().getLabelValue(key, fallback)` — the
 * existing per-tenant translation infrastructure backed by I18nBrandingLabel.
 * When react-i18next ships in Phase 4, the same keys become translation keys.
 */

export const LABEL_KEYS = Object.freeze({
  BUTTON: 'contextSwitcher.button',
  MENU_HEADER: 'contextSwitcher.menuHeader',
  ROLE_DONOR: 'contextSwitcher.role.donor',
  ROLE_ADVISOR: 'contextSwitcher.role.advisor',
  ROLE_CHARITY: 'contextSwitcher.role.charity',
  ROLE_ADMIN: 'contextSwitcher.role.admin',
  CONTEXT_FUND_PREFIX: 'contextSwitcher.context.fundPrefix',
})

export const DEFAULT_LABELS = Object.freeze({
  [LABEL_KEYS.BUTTON]: 'Switch',
  [LABEL_KEYS.MENU_HEADER]: 'Manage',
  [LABEL_KEYS.ROLE_DONOR]: 'Donor',
  [LABEL_KEYS.ROLE_ADVISOR]: 'Advisor',
  [LABEL_KEYS.ROLE_CHARITY]: 'Charity',
  [LABEL_KEYS.ROLE_ADMIN]: 'Administrator',
  [LABEL_KEYS.CONTEXT_FUND_PREFIX]: 'Fund',
})

export const ROLE_KEYS = Object.freeze({
  DONOR: 'donor',
  ADVISOR: 'advisor',
  CHARITY: 'charity',
  ADMIN: 'admin',
})

export const ROLE_LABEL_KEY = Object.freeze({
  [ROLE_KEYS.DONOR]: LABEL_KEYS.ROLE_DONOR,
  [ROLE_KEYS.ADVISOR]: LABEL_KEYS.ROLE_ADVISOR,
  [ROLE_KEYS.CHARITY]: LABEL_KEYS.ROLE_CHARITY,
  [ROLE_KEYS.ADMIN]: LABEL_KEYS.ROLE_ADMIN,
})
